/**
 * Which scanner skills the "Scans" page can run. Mirrors the backend's
 * app/core/scan_skills.py ALLOWED_SKILLS / SKILL_LABELS (kept in sync by
 * convention, not a shared package — see that file's comment for why).
 *
 * summaryKind picks which summary component a run renders with:
 *   "grade"   - letter grade + severity chips (security-scanner's findings.json)
 *   "verdict" - GO / READY_WITH_FIXES / NOT_READY banner + blocker list
 *               (code-review's findings.json)
 */

import { ShieldAlert, Rocket } from 'lucide-react';

export const SCAN_TYPES = [
  {
    key: 'security-scanner',
    label: 'Security Scan',
    icon: ShieldAlert,
    summaryKind: 'grade',
  },
  {
    key: 'code-review',
    label: 'Code Review',
    icon: Rocket,
    summaryKind: 'verdict',
  },
];

export const DEFAULT_SCAN_TYPE = 'security-scanner';

export const getScanType = (key) => (
  SCAN_TYPES.find((t) => t.key === key) || SCAN_TYPES[0]
);
